module.exports = __webpack_public_path__ + "bc9cad2b43666fe29bc531d8fc3a9700.png";